import api from "../api"
export default {
	async createFile(filename, filedata) {
		let formData = new FormData()
		formData.append("file", filedata)
		formData.append("filename", filename)
		let config = {
			headers: {
				"content-type": "multipart/form-data"
			}
		}
		let value = await api.post(`/files/`, formData, config)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async postFile(UserID, filename, ShortDescription, TimeOfUpload, ExpiryDate, filedata, PolicyCertificate) {
		let formData = new FormData()
		formData.append("file", filedata)
		formData.append("filename", filename)
		formData.append("UserID", UserID)
		formData.append("ShortDescription", ShortDescription)
		formData.append("TimeOfUpload", TimeOfUpload)
		formData.append("ExpiryDate", ExpiryDate)
		formData.append("PolicyCertificate", PolicyCertificate)
		let config = {
			headers: {
				"content-type": "multipart/form-data"
			}
		}
		let value = await api.post(`/policyfiles/`, formData, config)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async setOpenStatus(fileID, isOpen) {
		let value = await api.put(`/policyfiles/${fileID}`, { IsOpen: isOpen })
		if (!value.data || !value.data.error) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getFiledata() {
		let value = await api.get(`/filesdata/`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async getFiledataByID(id) {
		let value = await api.get(`/filesdata/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		return value.data.data[0]
	},
	async downloadFile(id, name) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let response = await api.get(`/filess/${id}`, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/pdf"
			}
		})
		const url = window.URL.createObjectURL(new Blob([response.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `${name}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
	async deleteCompanyFile(id) {
		let value = await api.delete(`/filess/${id}`)
		if (value?.data?.error?.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	async deleteFile(id) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let value = await api.delete(`/files/${id}`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
	},
	/**
     * Gets a list of invitation codes
     * @param {boolean} redeemed 
     * @param {number} offset 
     * @param {number} limit 
     */
	async list(hasBeenRedeemed, offset, limit) {
		let value = await api.get(`/files/`, {
			params: {
				offset,
				limit
			}
		})
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data
		return data
	},
	async info(id) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let value = await api.get(`/files/${id}/info`)
		if (!value.data || !value.data.error || !value.data.data) {
			throw new Error("Could not get response!")
		}
		if (value.data.error.length > 0) {
			let error = new Error(value.data.error[0].message)  
			error.code = value.data.error[0].code
			error.incidentID = value.data.error[0].incidentID
			throw error
		}
		let data = value.data.data[0]
		return data
	},
	async download(id, name) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let response = await api.get(`/files/${id}`, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/pdf"
			}
		})
		const url = window.URL.createObjectURL(new Blob([response.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `${name}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},

	async downloadOnsiteProofs(id, name) {
		if (typeof id !== "string" || id.length < 1) {
			throw new Error("ID must be a string longer than 0")
		}
		let response = await api.get(`/proofs/${id}`, {
			responseType: "blob",
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/pdf"
			}
		})
		const url = window.URL.createObjectURL(new Blob([response.data]))
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("target", "_blank")
		link.setAttribute("download", `${name}.pdf`)
		document.body.appendChild(link)
		link.click()
		document.body.removeChild(link)
	},
}